'use strict';

$ = jQuery;

// $(document).ready(function () {
//   jQuery.ajax({
//     url: viewHandler.url + "/" + viewHandler.post_id + "/" + Date.now(),
//     type: 'POST',
//     data: {},
//     success: function(response) {},
//     error: function(data) {}
//   });
// });

/*
* Evento de clique nos cards de modelos
*/
$('.jc-card-model a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Card',
    'eventLabel': $(this).attr('alt')
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Card',
    'eventLabel': $(this).attr('alt')
  });
});

/*
* Evento de clique nos cards ad
*/
$('#card-list-model-slider .jc-card-ad-catalog').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Ad native',
    'eventLabel': $(this).find('img').attr('alt')
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Ad native',
    'eventLabel': $(this).find('img').attr('alt')
  });
});

/*
* Evento de clique cta de ofertas no rodapé de mobile
*/
$('#model-cta-footer-mobile').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - CTA - Rodapé',
    'eventLabel': $(this).text()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - CTA - Rodapé',
    'eventLabel': $(this).text()
  });
});

$('#model-interest-cta').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Tenho Interesse',
    'eventAction': 'Clique - CTA Interesse',
    'eventLabel': $('#model-interest-cta').attr('aria-label')
  });

  gtag('event', 'Tenho Interesse', {
    'eventAction': 'Clique - CTA Interesse',
    'eventLabel': $('#model-interest-cta').attr('aria-label')
  });
});